import { Component, OnInit } from '@angular/core';

declare interface RouteInfo {
    path: string;
    title: string;
    icon: string;
    class: string;
}
export const ROUTES: RouteInfo[] = [
   // { path: '/login', title: 'loginss',  icon: 'users_single-02', class: '' },

    { path: '/dashboard', title: 'Dashboard',  icon: 'design_app', class: '' },
    { path: '/map', title: 'Map',  icon: 'location_map-big', class: '' },
    { path: '/chat', title: 'SUPPORT',  icon: 'location_map-big', class: '' },

    { path: '/restaurant', title: 'Restaurant',  icon: 'design_app', class: '' },
    { path: '/restaurantType', title: 'Restaurant Type',  icon: 'design_app', class: '' },
    { path: '/mealCategory', title: 'Meal Category',  icon: 'design_app', class: '' },

    // { path: '/orders', title: 'Orders',  icon: 'education_paper', class: '' },
    { path: '/drivers', title: 'Drivers',  icon: 'transportation_bus-front-12', class: '' },
    { path: '/customers/customers', title: 'Customers',  icon: 'education_paper', class: '' },
    { path: '/country/country-list', title: 'Country & City',  icon: 'education_paper', class: '' },
    { path: '/tags/tags', title: 'Tags',  icon: 'education_paper', class: '' },
    { path: '/shifts', title: 'Shift',  icon: 'education_paper', class: '' },
    { path: '/setting', title: 'Setting',  icon: 'education_paper', class: '' },
    { path: '/support', title: 'Support',  icon: 'education_paper', class: '' },


    // { path: '/icons', title: 'Icons',  icon: 'education_atom', class: '' },
    // { path: '/maps', title: 'Maps',  icon: 'location_map-big', class: '' },
    // { path: '/notifications', title: 'Notifications',  icon: 'ui-1_bell-53', class: '' },

    // { path: '/user-profile', title: 'User Profile',  icon: 'users_single-02', class: '' },
    // { path: '/table-list', title: 'Table List',  icon: 'design_bullet-list-67', class: '' },
    // { path: '/typography', title: 'Typography',  icon: 'text_caps-small', class: '' },
    // { path: '/upgrade', title: 'Upgrade to PRO',  icon:'objects_spaceship', class: 'active active-pro' }

];

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  menuItems: any[];

  constructor() { }

  ngOnInit() {
    this.menuItems = ROUTES.filter(menuItem => menuItem);
  }
  isMobileMenu() {
      if ( window.innerWidth > 991) {
          return false;
      }
      return true;
  }
}
